import React from 'react';
import { FaChevronDown } from "react-icons/fa";
import styles from "../styles.module.scss";
import AAccordion from '../../../../../components/AAccordion/AAccordion';

export const DataCell = ({ label, value, children }) => {
  return (
    <div className="d-flex flex-column">
      <span className={styles['label']}>{label} :</span>
      <span className={styles['value']}>
        <span className="d-flex">
          {" "}
          {value || (!children && "-")} {children}
        </span>
      </span>
    </div>
  );
}


const StudentDetails = ({
    studentDetails,
    labelFieldMappings,
}) => {

    return (
        <AAccordion expandIcon={<FaChevronDown/>}>
                <h2 className='m-0'>Student Details</h2>

                <div className={`${styles['student-details-grid']}` + " mt-2"}>

                    {labelFieldMappings?.map(el => {
                        const { label, field, renderExtra } = el;
                        return (
                            <DataCell
                                label={label}
                                value={studentDetails[field]}
                                key={field}
                            >
                                {renderExtra}
                            </DataCell>
                        )
                    })}

                </div>

        </AAccordion>
    );
}

export default StudentDetails;